import React from "react";
import { merge, of } from "rxjs";
import { debounceTime, map, delay } from "rxjs/operators";
import xstream from "state-x-stream";
import PropTypes from "prop-types";
import eventEmitter from "../../eventEmitter";
import HelpModal from "./HelpModal";
import LayoutOptions from "./LayoutOptions";

function controller() {
  const { resizeTracker$ } = eventEmitter;
  return {
    height: merge(
      of(null),
      of(null).pipe(delay(100)),
      resizeTracker$.pipe(debounceTime(100))
    ).pipe(map(() => document.getElementById("menu-container")?.offsetHeight)),
  };
}

function CardsContainerSide({ height, children }) {
  const bottomPadding = 40;
  const maxHeight = `calc(100vh - ${height + bottomPadding}px)`;
  return (
    <div
      className="tw-sticky tw-flex-shrink-0 tw-text-xs side-container"
      style={{
        top: `${height}px`,
        maxHeight,
      }}
    >
      <div className="tw-pointer-events-auto tw-items-center tw-absolute tw-top-0 tw-right-0 tw-flex tw--mt-8 tw-mr-4">
        <LayoutOptions />
        <HelpModal />
      </div>

      <div
        style={{ maxHeight }}
        className="tw-p-4 tw-bg-white tw-overflow-auto"
      >
        {children}
      </div>
    </div>
  );
}

CardsContainerSide.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
};

CardsContainerSide.defaultProps = {
  children: null,
  height: 900,
};

export default xstream(controller)(CardsContainerSide);
